module.exports = __webpack_public_path__ + "static/media/chat.56d04a54.svg";